import NotificationByUserPage from './NotificationByUserPage';
export default NotificationByUserPage;